export const enum IDP_APPS {
  SKYMILES = 'SKYMILES',
  COMMON = 'COMMON'
}

export const enum EndpointKeys {
  SKYMILES_API_VOUCHERS = 'SKYMILES_API_VOUCHERS',
  SKYMILES_API_STATUS_TRACKER = 'SKYMILES_API_STATUS_TRACKER',
  SKYMILES_API_FUTURE_ACTIVITIES = 'SKYMILES_API_FUTURE_ACTIVITIES',
  SKYMILES_API_PROMOTIONS_MAIN = 'SKYMILES_API_PROMOTIONS_MAIN',
  SKYMILES_API_PROMOTIONS_MAIN_V2 = 'SKYMILES_API_PROMOTIONS_MAIN_V2',
  SKYMILES_API_PROMOTIONS_ENROLL = 'SKYMILES_API_PROMOTIONS_ENROLL',
  SKYMILES_API_PROMOTIONS_DETAILS = 'SKYMILES_API_PROMOTIONS_DETAILS',
  SKYMILES_API_PROMOTIONS_CONTENT = 'SKYMILES_API_PROMOTIONS_CONTENT',
  SKYMILES_API_PROMOTIONS = 'SKYMILES_API_PROMOTIONS',
  SKYMILES_API_PARTNERS_PROMOTIONS = 'SKYMILES_API_PARTNERS_PROMOTIONS',
  SKYMILES_API_MEMBERSHIP_CARD = 'SKYMILES_API_MEMBERSHIP_CARD',
  SKYMILES_API_ECREDITS = 'SKYMILES_API_ECREDITS',
  SKYMILES_API_ACCOUNT_ACTIVITY = 'SKYMILES_API_ACCOUNT_ACTIVITY',
  SKYMILES_AEM_PROMOTIONS_FEATURE_FLAGS = 'SKYMILES_AEM_PROMOTIONS_FEATURE_FLAGS',
  SKYMILES_AEM_PROMOTIONS_ERROR_MESSAGES = 'SKYMILES_AEM_PROMOTIONS_ERROR_MESSAGES',
  SKYMILES_AEM_PROMOTIONS_CONTENT = 'SKYMILES_AEM_PROMOTIONS_CONTENT',
  SKYMILES_AEM_PARTNERS_ERROR_MESSAGES = 'SKYMILES_AEM_PARTNERS_ERROR_MESSAGES',
  SKYMILES_AEM_OVERVIEW_WELCOME_TOUR = 'SKYMILES_AEM_OVERVIEW_WELCOME_TOUR',
  SKYMILES_AEM_OVERVIEW_FEATURE_FLAGS = 'SKYMILES_AEM_OVERVIEW_FEATURE_FLAGS',
  SKYMILES_AEM_OVERVIEW_ERROR_MESSAGES = 'SKYMILES_AEM_OVERVIEW_ERROR_MESSAGES',
  SKYMILES_AEM_OVERVIEW_CONTENT = 'SKYMILES_AEM_OVERVIEW_CONTENT',
  SKYMILES_AEM_OVERVIEW_MAIN_CONTENT = 'SKYMILES_AEM_OVERVIEW_MAIN_CONTENT',
  SKYMILES_AEM_LANDING_PAGE_MENU = 'SKYMILES_AEM_LANDING_PAGE_MENU',
  SKYMILES_AEM_LANDING_PAGE_MEDALLION_BANNER = 'SKYMILES_AEM_LANDING_PAGE_MEDALLION_BANNER',
  SKYMILES_AEM_LANDING_PAGE_FEATURE_FLAGS = 'SKYMILES_AEM_LANDING_PAGE_FEATURE_FLAGS',
  SKYMILES_AEM_LANDING_PAGE_ERROR_MESSAGES = 'SKYMILES_AEM_LANDING_PAGE_ERROR_MESSAGES',
  SKYMILES_AEM_AUTH_CONFIG = 'SKYMILES_AEM_AUTH_CONFIG',
  SKYMILES_AEM_ACCOUNT_ACTIVITY_FEATURE_FLAGS = 'SKYMILES_AEM_ACCOUNT_ACTIVITY_FEATURE_FLAGS',
  SKYMILES_AEM_ACCOUNT_ACTIVITY_ERROR_MESSAGES = 'SKYMILES_AEM_ACCOUNT_ACTIVITY_ERROR_MESSAGES',
  SKYMILES_AEM_ACCOUNT_ACTIVITY_CONTENT = 'SKYMILES_AEM_ACCOUNT_ACTIVITY_CONTENT',
  SKYMILES_API_ACCOUNT_ACTIVITY_CONTENT = 'SKYMILES_API_ACCOUNT_ACTIVITY_CONTENT',
  SKYMILES_AEM_EDUCATIONAL_CONTENT = 'SKYMILES_AEM_EDUCATIONAL_CONTENT',
  SKYMILES_API_EARNS_SUMMARY = 'SKYMILES_API_EARNS_SUMMARY',
  SKYMILES_AEM_MERGE_DUPLICATE_ACCOUNTS_CONTENT = 'SKYMILES_AEM_MERGE_DUPLICATE_ACCOUNTS_CONTENT',
  SKYMILES_API_MERGE_DUPLICATE_ACCOUNTS_VALIDATE = 'SKYMILES_API_MERGE_DUPLICATE_ACCOUNTS_VALIDATE',
  SKYMILES_API_MERGE_DUPLICATE_ACCOUNTS_REVIEW = 'SKYMILES_API_MERGE_DUPLICATE_ACCOUNTS_REVIEW',
  SKYMILES_AEM_ROLLOVER_CONTENT = 'SKYMILES_AEM_ROLLOVER_CONTENT',
  SKYMILES_AEM_ROLLOVER_FEATURE_FLAGS = 'SKYMILES_AEM_ROLLOVER_FEATURE_FLAGS',
  SKYMILES_AEM_ROLLOVER_ERROR_MESSAGES = 'SKYMILES_AEM_ROLLOVER_ERROR_MESSAGES',
  SKYMILES_AEM_BUSINESS_TRAVELER_FEATURE_FLAGS = 'SKYMILES_AEM_BUSINESS_TRAVELER_FEATURE_FLAGS',
  SKYMILES_AEM_BUSINESS_TRAVELER_OVERVIEW = 'SKYMILES_AEM_BUSINESS_TRAVELER_OVERVIEW',
  SKYMILES_API_BUSINESS_TRAVELER_ELIGIBILITY = 'SKYMILES_API_BUSINESS_TRAVELER_ELIGIBILITY',
  SKYMILES_API_BUSINESS_TRAVELER_CANCELLATION = 'SKYMILES_API_BUSINESS_TRAVELER_CANCELLATION',
  SKYMILES_API_BUSINESS_TRAVELER_CUSTOMER_PROFILE = 'SKYMILES_API_BUSINESS_TRAVELER_CUSTOMER_PROFILE',
  SKYMILES_API_BUSINESS_TRAVELER_PROMOTIONS_ENROLL = 'SKYMILES_API_BUSINESS_TRAVELER_PROMOTIONS_ENROLL',
  SKYMILES_API_BUSINESS_TRAVELER_PROMOTIONS_DETAILS = 'SKYMILES_API_BUSINESS_TRAVELER_PROMOTIONS_DETAILS',
  SKYMILES_AEM_BUSINESS_TRAVELER_ENROLLMENT_COUNTRIES = 'SKYMILES_AEM_BUSINESS_TRAVELER_ENROLLMENT_COUNTRIES',
  SKYMILES_API_BUSINESS_TRAVELER_ENROLL = 'SKYMILES_API_BUSINESS_TRAVELER_ENROLL',
  SKYMILES_API_SKYCLUB_TRACKER = 'SKYMILES_API_SKYCLUB_TRACKER'
}

export const enum EndpointKeysCommon {
  APP_AUTH_CONFIG_JSON = 'APP_AUTH_CONFIG_JSON',
  PERSONALIZATION_ENGINE_URL = 'PERSONALIZATION_ENGINE_URL',
  GET_PERSONALIZED_CONTENT_URL = 'GET_PERSONALIZED_CONTENT_URL',
  MONO_COMMON_PE_SERVER_TIMEOUT = 'MONO_COMMON_PE_SERVER_TIMEOUT',
  MONO_COMMON_PE_BROWSER_TIMEOUT = 'MONO_COMMON_PE_BROWSER_TIMEOUT',
  LOGOUT_TIMEOUT = 'LOGOUT_TIMEOUT',
  AIRLINE_CONTENT_AEM_URL = 'AIRLINE_CONTENT_AEM_URL'
}

export const enum Libraries {
  LANDING_PAGE = 'LANDING PAGE',
  OVERVIEW = 'OVERVIEW',
  PROMOTIONS = 'PROMOTIONS',
  ACCOUNT_ACTIVITY = 'ACCOUNT ACTIVITY',
  SHARED = 'SKYMILES SHARED',
  PARTNERS = 'PARTNERS',
  MERGE_DUPLICATE_ACCOUNTS = 'MERGE DUPLICATE ACCOUNTS',
  ROLLOVER = 'ROLLOVER',
  BUSINESS_TRAVELER = 'BUSINESS TRAVELER'
}

export const enum TYPE {
  LOCALE = 'en-us',
  OPTIONS_YEAR_DAY = 'numeric',
  OPTIONS_MONTH = 'short'
}

export enum BusinessRole {
  OWNER = 'owner',
  MANAGER = 'manager',
  BOTH = 'both'
}

export const ValidationPatterns = {
  businessName:
    '((?=^.{1,300}$)^[A-Za-z0-9](((?![\\!@$%^*()+=<>?\\`\\~:;\\[\\]\\{\\}\\&"\t\n\\v\f\r]|[^\\x20-\\x7F]).)*|)){1,300}$',
  postalCode: "^[a-zA-Z0-9\\s\\'/\\.\\-]{0,12}$",
  email: '(^[\\w-]+(?:\\.[\\w-]+)*@([A-Za-z0-9-]+\\.)+[A-Za-z]{2,13}){1,132}$',
  website: '^(https?:\\/\\/)?(www\\.)?.*\\..*$'
};
